wbApp.factory('domainsSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {
        var Domains = $resource('/restapi/domains/:id', {}, {
            'get': { method: 'GET', isArray: true, url: '/restapi/domains' },            
            'insert': { method: 'POST', url: '/restapi/domains' },
            'update': { method: 'PUT', url: '/restapi/domains/:id' },
            'delete': { method: 'DELETE', url: '/restapi/domains/:id' },
        });

        var domains;

        function getAllExpanded() {
            return repositorySvc.customGet('get', Domains, {
                expand: 'specializations'
            });
        }

        function extendDomainModel(d, name) {
            d.fullName = !!name ? name + ' - ' + d.name : d.name;
            d.expanded = !!d.specializations;
            d.visible = !(d.disabledForClients && _.reduce(d.specializations || [], function(acc, n) {
                return acc && n.disabledForClients;
            }, true));
            _.forEach(d.specializations || [], function(s) {
                extendDomainModel(s, d.name);
            });
        }        
        
        function getAllExpandedWithClientModel() {
            let deferred = $q.defer();
            let domains = [];
            domains.$promise = deferred.promise;

            getAllExpanded().$promise.then(function (data) {
                    _.forEach(data, function(d) {
                        extendDomainModel(d, null);
                    });
                    domains.push.apply(domains, data);
                    deferred.resolve(domains);
                },
                function(error) {
                    deferred.reject(error);
                });
            
            return domains;
        }
        
        function findFirstSelectable(domains) {
             let visibleDomain = _.find(domains, 'visible');
             if (!!visibleDomain && visibleDomain.disabledForClients) {
                 return _.find(visibleDomain.specializations || [], 'visible');
             }
             return visibleDomain;
        }

        function getAll(refresh) {
            if (!domains || refresh) {
                domains = repositorySvc.customGet('get', Domains);
            }

            return domains;
        }

        function createNew() {
            return {
                name: '',
                description: null
            };
        }

        function insert(domain, success, error) {
            return repositorySvc.customPost(
                'insert',
                Domains,
                domain,
                function (data) {
                    if (domains) {
                        domains.push(data);                        
                    }

                    if (success) 
                    {
                        success();
                    }
                },
                error);
        }

        function update(domain, success, error) {
            return repositorySvc.customPutWithParams(
                'update',
                Domains,
                {
                    id: domain.id
                },
                domain,
                function (data) {
                    if (domains) {
                        var current = _.find(domains, { id: domain.id });
                        if (current) {
                            angular.copy(domain, current);
                        }
                    }

                    if (success) {
                        success();
                    }
                },
                error);
        }

        function remove(domain, success, error) {
            return repositorySvc.customDelete(
                'delete',
                Domains,
                {
                    id: domain.id
                },
                function (data) {
                    if (domains) {
                        var i = _.findIndex(domains, { id: domain.id });
                        if (i !== -1) {
                            domains.splice(i, 1);
                        }
                    }

                    if (success) {
                        success();
                    }
                },
                error);
        }

        return {
            getAll: getAll,
            createNew: createNew,
            insert: insert,
            update: update,
            remove: remove,
            getAllExpanded: getAllExpanded,
            getAllExpandedWithClientModel: getAllExpandedWithClientModel,
            findFirstSelectable: findFirstSelectable
        }
    }]);